import React from "react";
import { Button, UnderConstruction } from "..";
import "./service-detail.css";
import { Link } from "react-router-dom";

function ServiceDetail({ className, title, description, detailImage, id, underConstruction }) {
  let classes = ["service-detail", className].join(" ");
  if (underConstruction) {
    return <UnderConstruction />;
  }
  else {
    return (
      <div className={classes}>
        <h2 className="mobile">{title}</h2>
        <div className={`service-illustration img-detail ${detailImage}`}></div>
        <div className="description">
          <h2 className="web">{title}</h2>
          <p>{description}</p>
          <Link to={`/service-detail/${id}/demo`} className="call-to-action">
            <Button>نمایش دمو</Button>
          </Link>
        </div>
      </div>
    );
  }
}

export default ServiceDetail;
